export default class SaleInvoiceUtil {
    static readonly NO_INVOICE_CODE = "-- No info. --";
}
